import { Component, OnInit } from '@angular/core';
import { DynamicFormConfig } from "../types/dynamic-form-config";
import { DynamicControl } from "../interfaces/DynamicControl";
import { ControlContainer, FormGroup, FormGroupDirective } from "@angular/forms";

@Component({
  selector: 'app-between-date',
  templateUrl: './between-date.component.html',
  viewProviders: [{
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }],
  styleUrls: ['./between-date.component.sass']
})
export class BetweenDateComponent implements OnInit, DynamicControl {
  config: DynamicFormConfig;
  form: FormGroup;

  constructor(private controlContainer: ControlContainer) { }

  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
  }

  checkDiffData() {
    if (this.form.get(this.config.name[1]).value < this.form.get(this.config.name[0]).value && this.form.get(this.config.name[1]).value != '' && this.form.get(this.config.name[1]).value != null) {
      this.form.controls[this.config.name[1]].reset()
    }
  }

}
